import { render } from "./LeagueSelection.vue?vue&type=template&id=f268fd8e&scoped=true"
import script from "./LeagueSelection.vue?vue&type=script&lang=js"
export * from "./LeagueSelection.vue?vue&type=script&lang=js"

import "./LeagueSelection.vue?vue&type=style&index=0&id=f268fd8e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f268fd8e"]])

export default __exports__